import { Injectable } from '@angular/core';

import { ApiHelperService } from '../../core/api-helper.service';
import { UploadService } from '../../core/upload.service';
import { StatementService } from '../statement/statement.service';

import { Merchant } from './merchant.model';
import { User } from '../user/user.model';

export type MerchantPlusMetadata = Merchant & { 
    owner: User,
    groupName: string | undefined,
    teamName: string | undefined
};

@Injectable({
    providedIn: 'root'
})
export class MerchantService {

    options = { authenticate: true, setRoot: true };

    constructor(
        private upload: UploadService,
        private api: ApiHelperService,
        private statementService: StatementService
    ) { }


    get(query: Partial<Merchant> = {}): Promise<Merchant[]> {
        return this.api.apiCallSane(
            '/merchants',
            'GET',
            this.api.getDefaultHeaders(),
            query,
            null,
            this.options
        ).then((ms: Partial<Merchant>[]) => ms.map(m => new Merchant(m)));
    }

    // TODO (jacob): Constructor?
    getAggregatedMerchants(query: Partial<Merchant>): Promise<MerchantPlusMetadata[]> {
        console.log('MerchantService getAggregatedMerchants', query);
        return this.api.apiCallSane(
            '/agg/merchants',
            'GET',
            this.api.getDefaultHeaders(),
            query,
            null,
            this.options
        );
    }

    getMerchantById(id: string): Promise<Merchant> {
        return this.api.apiCallSane(
            '/merchant',
            'GET',
            this.api.getDefaultHeaders(),
            { id },
            null,
            this.options
        ).then((m: Partial<Merchant>) => new Merchant(m));
    }

    updateMerchant(id: string, patch: Partial<Merchant>): Promise<Merchant> {
        return this.api.apiCallSane(
            '/merchant',
            'PATCH',
            this.api.getDefaultHeaders(),
            { id },
            patch,
            this.options
        ).then((m: Partial<Merchant>) => new Merchant(m));
    }


    updateMerchantOwner(id: string, ownerId: string): Promise<Merchant> {
        return this.api.apiCallSane(
            '/merchant',
            'PATCH',
            this.api.getDefaultHeaders(),
            { id },
            { ownerId },
            this.options
        ).then((m: Partial<Merchant>) => new Merchant(m));
    }

    archiveMerchant(id: string): Promise<Merchant> {
        return this.api.apiCallSane(
            '/merchant/archive',
            'PUT',
            this.api.getDefaultHeaders(),
            { id },
            null,
            this.options
        );
    }

    unarchiveMerchant(id: string): Promise<Merchant> {
        return this.api.apiCallSane(
            '/merchant/unarchive',
            'PUT',
            this.api.getDefaultHeaders(),
            { id },
            null,
            this.options
        );
    }

    create(merchant: Partial<Merchant>): Promise<Merchant> {
        return this.api.apiCallSane(
            '/merchant',
            'POST',
            this.api.getDefaultHeaders(),
            null,
            merchant,
            this.options)
            .then((m: Partial<Merchant>) => new Merchant(m));
    }
}
